























































































































































import Vue from 'vue';
import { Component, Ref } from 'vue-property-decorator';
import { IssueEntity } from '@/entities/issue.entity';
import moment from 'moment';
import CSelectButtonsApi from '@/components/Helper/Form/CSelectButtonsApi.vue';
import { mapState } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import CSelectButtons, {
  CSelectButtonsPropsItems,
} from '@/components/Helper/Form/CSelectButtons.vue';
import CTimePicker from '@/components/Helper/Form/CTimePicker.vue';
import IssueService from '@/services/issue.service';
import { UseService } from '@/services/service';
import { ValidationObserver } from 'vee-validate';
import VueI18n from 'vue-i18n';
import ContentEditable from '@/components/Helper/ContentEditable.vue';

@Component<BtnAddIssue>({
  components: {
    ContentEditable,
    CTimePicker,
    CSelectButtons,
    CSelectButtonsApi,
  },
  computed: {
    ...mapState('staff', ['current']),
  },
})
export default class BtnAddIssue extends Vue {
  dialog = false;
  title = '';
  current!: StaffEntity;

  @UseService(IssueService)
  service: IssueService;

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  newIssueData: Partial<IssueEntity> = {
    title: null,
    typeId: null,
    content: null,
    expiredTime: null,
    point: null,
  };

  get expiredTimeItems(): { text: VueI18n.TranslateResult; value: any }[] {
    return [
      {
        text: this.$t('time.inToday'),
        value: moment().endOf('day').toDate(),
      },
      {
        text: this.$t('time.untilTomorrow'),
        value: moment().add(1, 'day').endOf('day').toDate(),
      },
      {
        text: this.$tc('time.inDays', 3),
        value: moment().add(3, 'days').toDate(),
      },
      {
        text: this.$tc('time.inWeeks', 1),
        value: moment().add(1, 'week').toDate(),
      },
      {
        text: this.$tc('time.inMonths', 1),
        value: moment().add(1, 'month').toDate(),
      },
    ];
  }

  get pointOptionList(): CSelectButtonsPropsItems[] {
    return this.current.defaultGiftPoint.map((pt) => ({
      value: pt,
      text: `${pt}pt`,
    }));
  }

  get expireDate() {
    return moment(this.newIssueData.expiredTime).format('YYYY-MM-DD');
  }

  set expireDate(value: string) {
    const [y, m, d] = String(value).split('-').map(Number);
    this.newIssueData.expiredTime = moment(this.newIssueData.expiredTime)
      .year(y)
      .month(m)
      .day(d)
      .toDate();
  }

  get expireTime() {
    return moment(this.newIssueData.expiredTime).format('HH:mm');
  }

  set expireTime(value: string) {
    const [h, m] = String(value).split(':').map(Number);
    this.newIssueData.expiredTime = moment(this.newIssueData.expiredTime)
      .hour(h)
      .minute(m)
      .toDate();
  }

  async postIssue() {
    await this.service.createOne(this.newIssueData);
    this.dialog = false;
    this.newIssueData.title = null;
    this.newIssueData.content = null;
    this.newIssueData.typeId = null;
    this.newIssueData.expiredTime = moment().endOf('day').toDate();
    this.newIssueData.point = null;
    this.form.reset();
  }
}
